import React from 'react';
import { Countdown, PromoCodeButton } from '@noths/polaris-client-ribbons-design-system';
import { getTimeNHoursBefore } from '@noths/polaris-client-utils';

import * as styles from './OfferLabel.styles';

interface Countdown {
  endDate: string;
  message: string;
  threshold: number;
}

export interface OfferLabelProps {
  countdown?: Countdown;
  message: string;
  promoCode?: string;
  promoteAsSale?: boolean;
}

export const OfferLabel = ({
  countdown,
  message,
  promoCode,
  promoteAsSale = false,
}: OfferLabelProps) => {
  const tokenRegex = /({promocode}|{countdown})/gi;
  const showCountdown =
    countdown && Date.now() > getTimeNHoursBefore(countdown.endDate, countdown.threshold);
  const parts = showCountdown ? countdown.message.split(tokenRegex) : message.split(tokenRegex);

  const renderedMessage = parts.map((part, index) => {
    const key = `part-${index}`;

    if (part.toLowerCase() === '{promocode}' && promoCode) {
      return <PromoCodeButton key={key} promoCode={promoCode} />;
    }

    if (part.toLowerCase() === '{countdown}' && countdown) {
      return <Countdown endDateTime={countdown.endDate} key={key} />;
    }

    return part;
  });

  return (
    <div css={[styles.root, promoteAsSale ? styles.sale : styles.offer]}>{renderedMessage}</div>
  );
};
